module.exports = __webpack_public_path__ + "media/images/tip_imgarea-d0cdf53a5c6dc45afab3cfe05af7928b.png";